import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import content from "../static/content.json";
import "./FormPage.css"; 

const ViewFeedbackPage = ({ username, firstName, setIsAuthenticated }) => {
  const [items, setItems] = useState([]);
  const userId = localStorage.getItem("userId");
  const apiToken = localStorage.getItem("apiToken");
  const navigate = useNavigate();
  const editCaseId = localStorage.getItem("editCaseId");
  const staticText = content.ViewFeedbackPage;

  const isDemoMode = localStorage.getItem("userId") === "demo";

  // Define the questions array
  const questions = [
    "What is your name?",
    "How was your experience?",
    "Would you recommend us to a friend?",
    "What can we improve?",
    "How did you hear about us?",
    "Rate our service quality.",
    "Any additional comments?",
    "How likely are you to return?",
    "What did you like the most?",
    "What did you like the least?",
    // Add more questions if necessary
  ];

  // Define the answer field keys
  const answerFieldKeys = [
    "firstA",
    "secondA",
    "thirdA",
    "fourthA",
    "fifthA",
    "sixthA",
    "seventhA",
    "eighthA",
    "ninthA",
    "tenthA",
    "eleventhA", // Add more if you have more questions
  ];

  // useEffect(() => {
  //   if (isDemoMode) {
  //     const feedbackData = JSON.parse(localStorage.getItem("feedbackDataDemo"));
  //     if (feedbackData) {
  //       const feedbackString = questions
  //         .map((question, index) => {
  //           const answerKey = answerFieldKeys[index];
  //           const answer = feedbackData[answerKey];
  //           return answer ? `${question} ${answer}` : "";
  //         })
  //         .join("<br/>");

  //       setItems([
  //         {
  //           id: editCaseId,
  //           created: feedbackData.form_date,
  //           feedback_string: feedbackString,
  //         },
  //       ]);
  //     }
  //   } else {
  //     axios
  //       .get(
  //         `https://app.better-retter.de/api/patient/feedbacks/${editCaseId}`,
  //         {
  //           params: {
  //             api_token: apiToken,
  //             user_id: userId,
  //             software: "better-retter",
  //           },
  //         }
  //       )
  //       .then((response) => {
  //         const feedbacks = response.data.feedbacks || [];

  //         // Process each feedback item
  //         const modifiedFeedbacks = feedbacks.map((feedback) => {
  //           let feedbackString = "";

  //           // Ensure 'data' exists and is an object
  //           if (feedback.data && typeof feedback.data === "object") {
  //             // Iterate over the questions array
  //             questions.forEach((question, index) => {
  //               const answerKey = answerFieldKeys[index];
  //               const answer = feedback.data[answerKey];

  //               if (
  //                 answer &&
  //                 typeof answer === "string" &&
  //                 answer.trim() !== ""
  //               ) {
  //                 // Combine question and answer
  //                 feedbackString += `${question} ${answer}\n`;
  //               }
  //             });
  //           }

  //           // Trim any trailing whitespace or newline characters
  //           feedbackString =
  //             "Richtige Verdachtsdiagnose: Ja<br/>Richtige Rettungsdienstbehandlung: Ja<br/>Richtige Klinik angefahren: Ja";

  //           // Return a new feedback object with the 'feedback_string' property
  //           return {
  //             ...feedback,
  //             feedback_string: feedbackString,
  //           };
  //         });

  //         // Update the state with the modified feedbacks
  //         setItems(modifiedFeedbacks);
  //       })
  //       .catch((error) => {
  //         console.error("There was an error fetching the items!", error);
  //       });
  //   }
  // }, [apiToken, userId, editCaseId, isDemoMode]);

  useEffect(() => {
    if (isDemoMode) {
      const feedbackData = JSON.parse(localStorage.getItem("feedbackDataDemo"));
      if (feedbackData) {
        const feedbackString = `
        Richtige Verdachtsdiagnose: Ja<br/>
        Richtige Rettungsdienstbehandlung: Ja<br/>
        Richtige Klinik angefahren: Nein
      `;

        setItems([
          {
            id: editCaseId,
            created: feedbackData.form_date,
            feedback_string: feedbackString,
          },
        ]);
      }
    } else {
      axios
        .get(
          `https://app.better-retter.de/api/patient/feedbacks/${editCaseId}`,
          {
            params: {
              api_token: apiToken,
              user_id: userId,
              software: "better-retter",
            },
          }
        )
        .then((response) => {
          const feedbacks = response.data.feedbacks || [];

          // Process each feedback item
          const modifiedFeedbacks = feedbacks.map((feedback) => {
            let feedbackString = "";

            // Ensure 'data' exists and is an object
            if (feedback.data && typeof feedback.data === "object") {
              // Iterate over the questions array
              questions.forEach((question, index) => {
                const answerKey = answerFieldKeys[index];
                const answer = feedback.data[answerKey];

                if (
                  answer &&
                  typeof answer === "string" &&
                  answer.trim() !== ""
                ) {
                  // Combine question and answer
                  feedbackString += `${question} ${answer}\n`;
                }
              });
            }

            // Trim any trailing whitespace or newline characters
            feedbackString = feedbackString.trim();

            // Return a new feedback object with the 'feedback_string' property
            return {
              ...feedback,
              feedback_string: feedbackString,
            };
          });

          // Update the state with the modified feedbacks
          setItems(modifiedFeedbacks);
        })
        .catch((error) => {
          console.error("There was an error fetching the items!", error);
        });
    }
  }, [apiToken, userId, editCaseId, isDemoMode, questions, answerFieldKeys]);

  const handleView = () => {
    navigate("/exampleFeedbackView");
  };

  const handleDelete = (patient_id) => {
    axios
      .delete(
        `https://app.better-retter.de/api/patient/feedbacks/${patient_id}`,
        {
          params: {
            api_token: apiToken,
            user_id: userId,
            software: "better-retter",
          },
        }
      )
      .then(() => {
        // console.log(`Deleted feedback for patient ${patient_id}`);
        setItems(items.filter((item) => item.patient_id !== patient_id));
      })
      .catch((error) => {
        console.error("Error deleting feedback for patient:", error);
      });
  };

  return (
    <div className="page-container">
      {/* Navbar */}
      <nav className="navbar">
        <div className="navbar-content">
          <h1>Hallo {username || "Max Mustermann"}!</h1>
        </div>
      </nav>

      {/* Feedback Table */}
      <div className="table-container">
        <table className="table-overview">
          <thead>
            <tr>
              <th>{staticText.FeedbackNumberColumnName}</th>
              <th>{staticText.CreatedIssueColumnName}</th>
              <th>{staticText.FeedbackTextSummaryColumnName}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items.length > 0 ? (
              items.map((item, index) => (
                <React.Fragment key={item.id}>
                  {/* Main Feedback Row */}
                  <tr>
                    <td>{index + 1}</td>
                    <td>{item.created || "N/A"}</td>
                    <td>
                      {item.feedback_string
                        ? item.feedback_string
                            .split(/<br\s*\/?>/i)
                            .map((line, index) => (
                              <React.Fragment key={index}>
                                {line}
                                <br />
                              </React.Fragment>
                            ))
                        : "N/A"}
                    </td>
                    <td>
                      <button
                        className="action-button edit-button"
                        onClick={() => handleView()}
                      >
                        👀
                      </button>
                    </td>
                  </tr>

                  {/* Nested Feedback Rows */}
                  {item.feedbacks &&
                    item.feedbacks.length > 0 &&
                    item.feedbacks.map((feedback, feedbackIndex) => (
                      <tr key={feedback.feedback_id} className="feedback-row">
                        <td>{`${index + 1}.${feedbackIndex + 1}`}</td>
                        <td colSpan="4">
                          {feedback.content || "Keine Angabe"}
                        </td>
                      </tr>
                    ))}
                </React.Fragment>
              ))
            ) : (
              <tr>
                <td colSpan="7">Keine Angabe</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ViewFeedbackPage;
